import styled, {css} from 'styled-components'
import Div from 'shared/Div'

export default styled(Div)`
  flex: 1 1 auto;
  overflow: hidden;

  position: relative;

  ${props => props.flex && css`
    flex: ${props.flex};
  `}

  ${props => props.height && css`
    height: ${props.height};
  `}

  // used for extra empty items at end to make last row look uniform
  ${props => props.noheight && css`
    height: 0 !important;
    border: none !important;
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  `}

  ${props => props.aspect && css`
    width: 300px;

    &:before {
      content: '';
      float: left;
      padding-top: ${props.aspect};
    }
  `}

  ${props => props.cursor && css`
    cursor: pointer;
  `}

`

// alignItems and justifyContent attrs expect values
// wrap, column, center attrs don't expect values
// center is shorthand



// WEBPACK FOOTER //
// ./src/shared/FlexItem.js